/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowMoveUp = createReactComponent("outline", "arrow-move-up", "IconArrowMoveUp", [["path", { "d": "M12 13v-10", "key": "svg-0" }], ["path", { "d": "M9 6l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M12 17a2 2 0 1 1 0 4a2 2 0 0 1 0 -4z", "key": "svg-2" }]]);

export { IconArrowMoveUp as default };
//# sourceMappingURL=IconArrowMoveUp.mjs.map
